import type { JSX } from "react";

export function RouteSkeleton(): JSX.Element {
  return (
    <main className="app-page" style={{ paddingTop: 24 }}>
      <div className="mn-skel" style={{ height: 36, width: "60%", marginBottom: 16 }} />
      <div className="mn-skel" style={{ height: 12, width: "100%", marginBottom: 8 }} />
      <div className="mn-skel" style={{ height: 12, width: "92%", marginBottom: 8 }} />
      <div className="mn-skel" style={{ height: 12, width: "70%", marginBottom: 16 }} />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 12,
        }}
      >
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="mn-skel" style={{ aspectRatio: "3/4", borderRadius: 16 }} />
        ))}
      </div>
    </main>
  );
}
